<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工姓名：">
          <el-input v-model="formInline.userName" placeholder="请输入员工姓名" clearable size="small"
            @change="inputChange"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/baseSalary/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/baseSalary/index', 'create')" size="small" type="primary"
            class="el-icon-plus" @click="handleEditClick()">
            新增
          </el-button>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" :loading="loading" @rowDBClick="handleEditClick">
        <el-table-column slot="userInfo.chName" label="员工姓名" width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="handleShowHistory(scope.row)">
              {{ scope.row.userInfo.chName }}
            </el-link>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <!-- 编辑 -->
    <edit ref="edit"></edit>
    <!-- 历史记录 -->
    <history ref="history"></history>
  </div>
</template>

<script>
import {
  GetUserBaseSalaryPageList
} from "@/api/salaryApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import edit from './edit.vue'
import history from './history.vue'
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "基本工资",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 15,
        storeKeyId: "",
        userName: "",
      },
      storeList: [],
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          minWidth: "120",
          align: "center",
          fixed: "left",
        },
        {
          slot: "userInfo.chName",
          label: "员工姓名",
          width: "100",
          align: "center",
          fixed: "left",
        },
        {
          prop: "postName",
          label: "岗位",
          width: "110",
          align: "center",
          fixed: "left",
        },
        {
          prop: "baseSalary",
          label: "基础薪资",
          width: "100",
          align: "center",
        },
        {
          prop: "perfectAttendance",
          label: "全勤",
          width: "100",
          align: "center",
        },
        {
          prop: "postWage",
          label: "岗位薪资",
          width: "100",
          align: "center",
        },
        {
          prop: "socialSecuritySubsidy",
          label: "社保补贴",
          width: "100",
          align: "center",
        },
        {
          prop: "seniorityPay",
          label: "工龄补贴",
          width: "100",
          align: "center",
        },
        {
          prop: "requiredAttendance",
          label: "应出勤天数",
          width: "120",
          align: "center",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "170",
          align: "center",
        },
        {
          prop: "editor",
          label: "维护人",
          width: "120",
          align: "center",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          width: "170",
          align: "center",
        },
      ],
    };
  },
  // 注册组件
  components: {
    edit,
    history
  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetOrgInfoListByConfig();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetUserBaseSalaryPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 点击事件
    handleEditClick(row) {
      this.$refs.edit.editShow(row);
    },
    handleShowHistory(row) {
      this.$refs.history.showHistoryDialog(row.keyId, row.userInfo.chName);
    },
  },
};
</script>

<style scoped></style>